// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1yt41uce{padding:var(--ds-space-100,8px) var(--ds-space-100,8px)}\n._1ls2idpf:last-of-type{border-right:0}\n._1s7z1oij{border-right:var(--_1n7euq6)}\n._n7zl1oij{border-bottom:var(--_1n7euq6)}\n._n7zlidpf{border-bottom:0}._1lhcu2gc:first-of-type{padding-left:var(--ds-space-100,8px)}\n._1o59u2gc:last-of-type{padding-right:var(--ds-space-100,8px)}\n._bfhkchd4{background-color:var(--ds-elevation-surface-current,#fff)}", ""]);
// Exports
module.exports = exports;
